import { useHttp } from '@2r/frontend-component-library';
import { useMutation } from '@tanstack/react-query';

export function useUpdateItem<TData>(baseApiPath: string) {
    const http = useHttp(baseApiPath);

    const saveMutation = useMutation({
        mutationFn: (obj: TData) => http.post<TData>("/save", obj),
    });

    const createMutation = useMutation({
        mutationFn: (obj: TData) => http.post<TData>("/save?new=true", obj),
    })

    return {
        save: saveMutation.mutate,
        create: createMutation.mutate
    };
}